import { connectionStore, ConfigStore } from "../../stores";
import { STR_ERRORS } from "../../strings";
import { ConnectionNames } from "../../../contracts";
import { unsubscribe } from "../unsubscribe";
import { subscribe } from "../subscribe";
import { getQueryIDs } from "../getQueryIDs";
let timeout = 0;
function setQuery(store, r) {
    if (r.query) {
        store.set(r.query, r);
    }
}
export function applyQueries(store, connectionName, r, onlyConnect = false) {
    const conn = connectionStore.get(connectionName);
    if (typeof conn === "undefined") {
        throw new Error(STR_ERRORS.NoConnectionsAvailable);
    }
    if (typeof r.query === "undefined") {
        unsubscribe(store, conn, r);
        if (store.getAllConnections().length === 0) {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(() => {
                conn.deactivate().catch(undefined);
            }, ConfigStore.config.inactiveTTL_MS);
        }
        return;
    }
    clearTimeout(timeout);
    conn.isConnected()
        .then(x => x ? x : conn.connect())
        .then(x => {
        //Get query details from the store before we set the new query
        const ids = getQueryIDs(store, r);
        setQuery(store, r);
        if (!onlyConnect && ConfigStore.config.connections.jwt) {
            subscribe(store, conn, r, ids);
        }
        return x;
    })
        .catch(() => {
        setQuery(store, r);
        ConfigStore.config.tracking[ConnectionNames.sports].trackError({
            message: "Connection Failed",
            clientAction: "CONNECTION_ERROR",
        });
    });
}
//# sourceMappingURL=applyQueries.js.map